module.exports = __webpack_public_path__ + "static/media/9-gjerne.74181cd3.mp3";